"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NewTab = _interopRequireDefault(require("../Tab/NewTab"));
require("./NewTabBar.scss");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TabBar = function TabBar(_ref) {
  var tabs = _ref.tabs,
    activeTab = _ref.activeTab,
    setActiveTab = _ref.setActiveTab,
    _ref$disabledTabs = _ref.disabledTabs,
    disabledTabs = _ref$disabledTabs === void 0 ? [] : _ref$disabledTabs,
    _ref$unreadCounts = _ref.unreadCounts,
    unreadCounts = _ref$unreadCounts === void 0 ? {} : _ref$unreadCounts;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(['commons']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-new-tab-bar' + (collapsed ? ' collapsed' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-new-tab-bar-title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-new-tab-bar-title-font"
  }, t('media')), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-new-tab-bar-title-icon',
    onClick: function onClick() {
      return setCollapsed(function (o) {
        return !o;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon clickable chevron-' + (collapsed ? 'right' : 'left')
  }))), tabs.map(function (tab, i) {
    return /*#__PURE__*/_react["default"].createElement(_NewTab["default"], {
      key: i,
      index: i + 1,
      title: t('types.' + tab),
      active: activeTab === tab,
      disabled: disabledTabs.includes(tab),
      unread: unreadCounts[tab],
      onClick: function onClick() {
        return setActiveTab(tab);
      },
      collapsed: collapsed
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: 'gcl-icon ' + tab.toLowerCase()
    }));
  }));
};
TabBar.propTypes = {
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  title: _propTypes["default"].objectOf(_propTypes["default"].string),
  activeTab: _propTypes["default"].string.isRequired,
  setActiveTab: _propTypes["default"].func.isRequired,
  disabledTabs: _propTypes["default"].arrayOf(_propTypes["default"].string),
  unreadCounts: _propTypes["default"].objectOf(_propTypes["default"].number)
};
var _default = exports["default"] = TabBar;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/TabBar/NewTabBar.js
// module id = 1425
// module chunks = 0